import script from "./TradePassportClients.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportClients.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportClients.vue?vue&type=style&index=0&id=e8795704&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8795704"]])

export default __exports__